import { getApiClient } from '../api-client'

export type GameComment = {
  id?: number
  gameId: string
  userId: number
  userName: string
  commentText: string
  createdAt?: string
}

const baseUrl = '/GameComment'

const gameCommentApi = {
  async getGameComments(gameId: string) {
    const apiClient = getApiClient()

    const response = await apiClient.get<GameComment[]>(
      `${baseUrl}/Game/${gameId}`
    )

    return response.data
  },

  async addComment(comment: GameComment) {
    const apiClient = getApiClient()

    const response = await apiClient.post<GameComment>(
      baseUrl,
      comment
    )

    return response.data
  },

  async deleteComment(
    id: number,
    userId: number
  ) {
    const apiClient = getApiClient()

    await apiClient.delete(
      `${baseUrl}/${id}?userId=${userId}`
    )
  }
}

export default gameCommentApi